import { giphyDarkCharcoal, giphyRed } from '@giphy/js-brand'
import React, { useContext } from 'react'
import styled from 'styled-components'
import CreationToolOutputType from '../../../../types/output-type'
import CreationToolStatus from '../../../../types/status'
import { SquareButton } from '../../../buttons'
import { CreationToolUploadContext } from '../../manager'
import { CreationToolUploadSource } from '../../types'
import { ErrorIcon } from '../icons'

const Button = styled(SquareButton)`
    box-sizing: border-box;
    display: flex;
    flex-shrink: 0;
    justify-content: center;
    margin-left: 6px;
    min-width: 32px;
    padding: 0 8px;
    position: relative;
    width: auto;

    &:hover {
        background-color: ${giphyDarkCharcoal};
    }

    span {
        display: inline-block;
        font-weight: bold;
        font-size: 15px;
        padding: 0 5px;
    }

    svg {
        display: block;
        height: 16px;
    }

    i {
        display: block;
        height: 12px;
        line-height: 1;
        transition: transform 0.2s ease-out;
    }

    &:last-child {
        margin-right: 10px;
    }
`

const RemoveButton = styled(Button)`
    &:hover {
        background-color: ${giphyRed};
    }
`

type Props = {
    source: CreationToolUploadSource
    isBulk: boolean
    isPreviewing: boolean
    onTogglePreview: (isPreviewing: boolean) => void
}

const CreationUploadItemButtons = ({ source, isBulk, isPreviewing, onTogglePreview }: Props) => {
    const { removeUploadSource } = useContext(CreationToolUploadContext)
    const { id, error, status, uploadedId, outputType } = source

    // uploaded
    if (uploadedId) {
        const typeTitle = CreationToolOutputType.title(outputType)
        const basePath = CreationToolOutputType.uploadedBasePath(outputType)
        return (
            <Button as="a" href={`${basePath}/${uploadedId}`} rel="noopener noreferrer" target="_blank">
                <span>Open {typeTitle}</span>
                <i className="ss-action" />
            </Button>
        )
    }

    // uploading
    if (status !== CreationToolStatus.Idle) {
        return (
            <Button style={{ pointerEvents: 'none' }}>
                <span>{CreationToolStatus.description(status)}...</span>
            </Button>
        )
    }

    return (
        <>
            {error && (
                <Button onClick={() => onTogglePreview(true)}>
                    <ErrorIcon />
                    <span>Error</span>
                </Button>
            )}
            {isBulk && (
                <Button onClick={() => onTogglePreview(!isPreviewing)}>
                    <i className="ss-navigatedown" style={{ transform: `rotate(${isPreviewing ? 180 : 0}deg)` }} />
                </Button>
            )}
            <RemoveButton onClick={() => removeUploadSource(id)}>
                <i className="ss-delete" />
            </RemoveButton>
        </>
    )
}

export default CreationUploadItemButtons
